(ns manage.export-display-modal.view
  (:require ["@mui/material/Box$default" :as Box]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Link$default" :as Link]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            [clojure.string :as str]
            [common.modal.view :refer [defmodal modal]]
            [common.resource.query.adserver :refer [rename-adserver-to-new-name]]
            [common.widgets.input :refer [input]]
            [common.widgets.table :as t]
            [re-frame.core :as rf]
            [uix.core :refer [$]]))

(defn error-mapping [spec]
  (case spec
    "api-unavailable" #(str/join " "
                                 ["The external service while exporting adset to"
                                  (rename-adserver-to-new-name (:adserverName %))
                                  "was unavailable. Please try again later."])
    "invalid-credentials" #(str "The provided credentials for the selected adserver configuration are invalid. "
                                "Please check the adserver configuration and try again.")
    "invalid-advertiser-id" #(str/join " "
                                       ["The configured advertiser-id for advertiser"
                                        (rename-adserver-to-new-name (:adserverName %))
                                        "is not valid."])
    "missing-backup-image" #(str "Missing a backup image. Please correct these settings for the advertiser and try again.")
    "missing-backup-landing-page-url" #(str "No backup landing page url configured for advertiser "
                                            (rename-adserver-to-new-name (:adserverName %))
                                            ".")
    "uncovered" #(str "Not all placeholder required for the configure templates are configured.")

    (fn [{:keys [message]}]
      [:<> "Something unexpected went wrong." [:br] "Api response: " message])))

(defn export-table-row
  [type {:keys [width height exportUrl creativeUrl status spec exportName name] :as props} createdAt]
  (let [url (or exportUrl creativeUrl)]
    [t/table-row {}
     [t/table-cell {}
      (str width "x" height)]
     [t/table-cell {}
      (or exportName name)]
     [t/table-cell {}
      [:> Icon {:color (if (= "error" status) "error" "success")}
       (if (= "error" status) "clear" "done")]]
     [t/table-cell {}
      (if (= "error" status)
        [:> Typography
         {:sx {:white-space "pre-wrap"
               :word-wrap "break-word"}}
         ((error-mapping spec) props)]
        (if (= type "manual")
          (if (or (nil? createdAt)
                  (< (js/Date. (.setDate (js/Date.) (- (.getDate (js/Date.)) 7))) (* 1000 createdAt)))
            [:a {:href url}
             [:> Icon {:color "primary"}
              "file_download"]]
            "no longer available")
          [:> Link {:href url
                    :target "_blank"
                    :sx {:overflow "hidden"
                         :text-overflow "ellipsis"}}
           url]))]]))

(defn export-table-header []
  [t/table-row {}
   [t/table-head {}
    "Dimensions"]
   [t/table-head {}
    "Export Name"]
   [t/table-head {}
    "Result"]
   [t/table-head {}
    "Details"]])

(defn upload-instruction-table-row
  [name value]
  [t/table-row {}
   [t/table-cell {}
    name]
   [t/table-cell {}
    [:> Stack
     {:direction "row"}
     ($ input
        {:type "text"
         :readOnly true
         :value value})
     [:> Button {:variant "text"
                 :on-click #(rf/dispatch [:page.export-display/copy-link value])}
      "Copy"]]]])

(defn upload-instructions-table-header []
  [t/table-row {}
   [t/table-head {}
    "Name"]
   [t/table-head {}
    "Landing page"]])

(defmodal last-export-result :page.export-display/last-export-result
  {:max-width "xl"}
  [{{:keys [type templateExports adserverName meta createdAt]} :export-result :as props}]
  (let [adserverName (rename-adserver-to-new-name adserverName)
        title (if (= "manual" type)
                "1. Creative overview (Downloads are available for a maximum of 7 days)"
                "Creative overview")]
    [modal
     {:title "Export Result"
      :modifier :info
      :footer [:> Button {:variant "contained"
                          :on-click #(rf/dispatch [:modal/close])}
               "Close"]}
     [:div
      title
      [t/table {:style {:min-height 0}}
       [export-table-header]
       (for [export templateExports]
         ^{:key (or (:revisionId export) (:exportUrl export))} [export-table-row type export createdAt])]
      (when (= "manual" type)
        [:> Box {:mt 3}
         (case adserverName
           "Google CM360"
           [:<>
            "2. Configure clicktags in DCM"
            [t/table {}
             [upload-instructions-table-header]
             (for [[name link-tag] (:clickTags meta)]
               ^{:key name} [upload-instruction-table-row name link-tag])]]

           "Xandr"
           [:<>
            "2. Configure landing page url"
            [:> Stack {:direction "row"
                       :mt 2}
             ($ input
                {:type "text"
                 :readOnly true
                 :value (:landingPageUrl meta)})
             [:> IconButton {:on-click #(rf/dispatch [:page.export-display/copy-link (:landingPageUrl meta)])}
              [:> Icon "content_copy"]]]]

           nil)])]]))
